// src/utils/urgencia.js
// Antigüedad de una orden / lead / tarjeta y su nivel de urgencia — UNA sola
// definición para todos los tableros (Kanban operativo, Kanban comercial,
// captación de Mantenimientos) y el generador de rutas.
//
// Antes cada pantalla tenía su propia copia de calcDias/diasColor con umbrales
// ligeramente distintos (7 en los Kanban, 30 en RouteGenerator, 7·4=28 en el
// comercial), así que un director tenía que mirar tres pantallas que contaban
// distinto lo mismo. Ahora el umbral se cambia aquí y en un solo sitio.

export const UMBRAL_ATENCION = 7;   // días esperando → requiere atención (ámbar)
export const UMBRAL_URGENTE  = 30;  // días esperando → urgente (rojo)

// Días transcurridos desde `dateStr` hasta hoy, ambos a medianoche local.
// null si la fecha falta o no es válida.
export function diasEspera(dateStr) {
  if (!dateStr) return null;
  const fecha = new Date(dateStr);
  if (isNaN(fecha.getTime())) return null;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  fecha.setHours(0, 0, 0, 0);
  return Math.floor((hoy - fecha) / 86400000);
}

// 'ok' | 'atencion' | 'urgente' | null
export function nivelUrgencia(dias) {
  if (dias === null || dias === undefined) return null;
  if (dias > UMBRAL_URGENTE)  return 'urgente';
  if (dias > UMBRAL_ATENCION) return 'atencion';
  return 'ok';
}

export function esUrgente(dias)        { return nivelUrgencia(dias) === 'urgente'; }
export function requiereAtencion(dias) { const n = nivelUrgencia(dias); return n === 'atencion' || n === 'urgente'; }

// Clase Tailwind de color de texto según el nivel.
export function claseUrgencia(dias) {
  switch (nivelUrgencia(dias)) {
    case 'urgente':  return 'text-red-600 font-semibold';
    case 'atencion': return 'text-amber-600';
    case 'ok':       return 'text-green-600';
    default:         return 'text-gray-400';
  }
}
